import { ReactElement } from 'react';
import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';

export const Text = ({ rootClassName, ...restProps }: TextProps): ReactElement => (
  <Typography.Text
    rootClassName={['custom-ant-typography', rootClassName].join(' ')}
    {...restProps}
  />
);
